import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import StatsBar from "@/pages/home/components/StatsBar";
import Services from "@/pages/home/components/Services";
import Commercial from "@/pages/home/components/Commercial";
import Gallery from "@/pages/home/components/Gallery";
import Reviews from "@/pages/home/components/Reviews";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";
import MobileCallBar from "@/pages/home/components/MobileCallBar";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <StatsBar />
        <Services />
        <Commercial />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <div className="h-20 lg:hidden" aria-hidden="true" />
      <MobileCallBar />
    </div>
  );
}